import React from 'react';
import { Route, Switch } from 'react-router';
import Entrypoint from './components/Entrypoint';
import Products from './pages/Products';
import Simulator from './pages/Simulator';
import SubscriptionInfo from './pages/SubscriptionInfo';
import ProductEdit from './pages/ProductEdit';
import OptionalRecharge from './pages/OptionalRecharge';

const routes = (
  <div>
    <Switch>
      <Route path="/" exact component={Entrypoint} />
      <Route path="/simulador" exact component={Simulator} />
      <Route path="/assinar" exact component={Products} />
      <Route path="/editar-dados" exact component={SubscriptionInfo} />
      <Route path="/editar-produto" exact component={ProductEdit} />
      <Route path="/recarga-opcional/:combo" exact component={OptionalRecharge} />
    </Switch>
  </div>
);

export default routes;
